import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';
import { isTextLinkProps } from '../../utils/is-link-props';
import styles from "./link.module.css";
const textLinkClass = 'text-link';
const iconLinkClass = 'icon-link';
export const TextLink = ({ href, target, rel, onClick, title, linkText, className, icon, variant, size, isExternal, iconPosition = 'left', onContextMenu, 'aria-label': ariaLabel, linkTag, linkTagColor = 'grey' }) => {
    const modifiedIconPosition = isExternal ? 'right' : iconPosition;
    const chooseIcon = () => {
        if (isExternal) {
            return React.createElement(Icon, { ...icon, name: "external-link--small", className: styles[`${textLinkClass}__icon`], "aria-hidden": true });
        }
        else if (icon) {
            return React.createElement(Icon, { ...icon, className: styles[`${textLinkClass}__icon`], "aria-hidden": true });
        }
    };
    const navTag = () => {
        if (linkTag) {
            return (React.createElement("span", { className: classnames(styles[`${textLinkClass}__tag--${linkTagColor}`], styles[`${textLinkClass}__tag`]) },
                React.createElement("i", null, "\u00B7"),
                linkTag));
        }
    };
    const classes = classnames(styles[textLinkClass], { [styles[`${textLinkClass}--${variant}`]]: variant }, {
        [styles[`${textLinkClass}--button`]]: [
            'button-primary',
            'button-primary-lime',
            'button-primary-brabus',
            'button-secondary',
            'button-ghost',
            'button-secondary-on-media'
        ].includes(variant)
    }, { [styles[`${textLinkClass}--icon-${modifiedIconPosition}`]]: modifiedIconPosition }, { [styles[`${textLinkClass}--${size}`]]: size }, className);
    return (React.createElement("a", { href: href, target: target, className: classes, rel: rel, onClick: onClick, title: title, "data-testid": "text-link-component", "aria-label": ariaLabel, onContextMenu: onContextMenu },
        React.createElement("span", { className: styles[`${textLinkClass}__text`] },
            linkText,
            navTag()),
        chooseIcon()));
};
export const IconLink = ({ href, target, rel, onClick, className, icon, variant = 'button-primary', size = '300', 'aria-label': ariaLabel, onContextMenu }) => {
    const classes = classnames(styles[iconLinkClass], { [styles[`${iconLinkClass}--${variant}`]]: variant }, {
        [styles[`${iconLinkClass}--button`]]: [
            'button-primary',
            'button-primary-brabus',
            'button-secondary',
            'button-ghost',
            'button-secondary-on-media'
        ].includes(variant)
    }, { [styles[`${iconLinkClass}--${size}`]]: size }, className);
    return (React.createElement("a", { href: href, target: target, className: classes, rel: rel, onClick: onClick, "aria-label": ariaLabel, onContextMenu: onContextMenu },
        React.createElement(Icon, { ...icon, className: styles[`${iconLinkClass}__icon`] })));
};
/**
 * The Link component is typed by a union of TextLinkProps or IconLinkProps. The props you give it determine if its a IconLink
 * or a TextLink component. While you can use TextLink or IconLink directly we would recommend to use Link.
 *
 * Not adding children will result in an IconLink. Using the icon prop makes the aria-label prop mandatory.
 * Using children will make the icon prop optional and will result in an TextLink.
 */
export const Link = (props) => {
    if (isTextLinkProps(props)) {
        return React.createElement(TextLink, { ...props });
    }
    return React.createElement(IconLink, { ...props });
};
//# sourceMappingURL=index.js.map